import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { HttpService } from "../../service/HTTPService/HttpService";
import { DatePipe } from "@angular/common";
import { SendDateService } from "./senddate.service";
import { ApiService } from "../../service/apiUrls/apiUrl.service";

@Component({
  selector: "app-actions-cell",
  template: `<div id="alarmstatus">
    <div
      id="detailedsiteList1"
      style="overflow:hidden;text-overflow:ellipsis"
      *ngIf="alarms"
    >
      <div
        style="padding-right:8px; padding-left: 5px;"
        (click)="displayAlarm(params)"
        placement="right"
        #popover="ngbPopover"
        [ngbPopover]="alarmInfo"
        container="body"
      >
        <img
          src="assets/img/1.png"
          alt="Bell Icon"
          width="{{ width }}"
          height="{{ height }}"
        />
      </div>
      <div style="padding-right: 12px; display: inline">
        <ng-template #alarmInfo>
          <div id="alarmList">
            <div>
              <b>{{ siteDetails }}</b>
            </div>
            <div *ngFor="let mod of module; index as i">
              <div
                style="padding:5px 10px;
              background-color: #dddd;
          "
              >
                <b>{{ mod.Name }}</b>
              </div>
              <div *ngFor="let item of mod.Data">
                <ul class="alarmInfo">
                  <li>
                    {{ item.Alarm }}
                    <label style="padding-left: 15px;" class="listLabel">{{
                      item["GeneratedOn"]
                    }}</label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div> `,
  styles: [
    `
      .alarmInfo {
        border-bottom: 1px solid #dddddd;
        list-style-type: none;
        margin: 0px;
        padding: 10px;
        background: #ffffff;
      }
      .listLabel {
        margin-bottom: 5px;
        float: right;
      }
      #alarmList {
        height: 270px;
        overflow-y: scroll;
      }
    `,
  ],
})
export class alarmStatusrenderer implements ICellRendererAngularComp {
  public params: any;
  public colors = "";
  public width = "";
  public height = "";
  public sid = "";
  public link = "";
  alarms = true;
  module;
  DCPowerDatas1 = false;
  DCPowerDatas = true;
  site;
  lastUp;
  lastUpdated;
  datetimeformat;
  siteCode;
  siteName;
  alarmList = [];
  batteryStatus;
  selectedDateFormat;
  selectedTimeFormat;
  format;
  timeFormatforGrid;
  siteDetails;
  constructor(
    private urlAuthentication: BindingURLService,
    private http: HttpService,
    private datePipe: DatePipe,
    private dateService: SendDateService,
    private apiUrl :ApiService
  ) {}
  agInit(params: any): void {
    let priority = "";
    this.colors = "";
    this.params = params;
    priority = this.params.data.BatteryAlarmStatus;
    this.sid = this.params.data.SiteID;
    this.site = this.params.data.SiteName;
    this.lastUp = this.params.data.LastUpdated;
    this.batteryStatus = this.params.data.BatteryAlarmStatus;
    this.link = "#/siteDetails";
    const str = '{"siteID":"' + this.sid + '"}';
    const encr = window.btoa(str);
    this.link = this.link + "?e=" + encr;
    if (priority == "1") {
      this.width = "14";
      this.height = "14";
      this.alarms = true;
    } else {
      this.alarms = false;
      this.width = "0";
      this.height = "0";
    }
  }

  ngOnInit() {
    this.datetimeformat = this.dateService.getSharedData();
  }

  refresh(): boolean {
    return false;
  }
  opennewwindow() {
    window.open(this.link);
  }


  displayAlarm(val) {
    this.http
      .get(this.urlAuthentication.itocUrl + this.apiUrl.liAlarmsList + this.sid)
      .subscribe(
        (res) => {
          this.siteCode = "";
          this.siteName = "";
          this.lastUpdated = "";
          this.module = [];
          this.siteDetails = "";
          let getResp: string = JSON.stringify(res);
          const resp = JSON.parse(getResp);
          this.module = resp;

          this.siteCode = val.data.SiteCode;
          this.siteName = val.data.SiteName;
          let dt = val.data.LastUpdated;

          if (this.datetimeformat.includes("tt")) {
            this.format = this.datetimeformat.replace("tt", "a");
          } else if (this.datetimeformat.includes("Decimal")) {
            this.format = this.datetimeformat.replace(
              "HH:mm(Decimal)",
              "HH:mm"
            );
          } else {
            this.format = this.datetimeformat;
          }
          const lastUpdatedTime = this.datePipe.transform(dt, this.format);
          this.lastUpdated = lastUpdatedTime;
          this.siteDetails =
            this.siteCode + " - " + this.siteName + " - " + this.lastUpdated;
        },
        (error) => {
          console.error(error);
          
          
        }
      );
  }
}
